import { Link, NavLink, useNavigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { LayoutDashboard, Inbox, Briefcase, Sparkles, BookOpen, MessageSquare, HelpCircle, Users, Image, Instagram, Settings, LogOut } from "lucide-react";

const ITEMS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
  { to: "/admin/projects", label: "Projects", icon: Briefcase },
  { to: "/admin/services", label: "Services", icon: Sparkles },
  { to: "/admin/blog", label: "Blog", icon: BookOpen },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquare },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/team", label: "Team", icon: Users },
  { to: "/admin/media", label: "Media", icon: Image },
  { to: "/admin/instagram", label: "Instagram", icon: Instagram },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (user === false) nav("/admin/login", { replace: true, state: { from: loc.pathname } });
  }, [user, nav, loc]);

  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] text-[#7A736C]">Loading…</div>;
  if (!user) return null;

  return (
    <div className="min-h-screen bg-[#F2EFE9] text-[#2B2927] flex">
      <aside data-testid="admin-sidebar" className="w-64 bg-[#1A1918] text-[#EAE6DF] hidden md:flex flex-col fixed h-screen">
        <div className="p-6 border-b border-[#3A3734]">
          <Link to="/admin" className="font-serif text-3xl tracking-tight text-[#F9F8F6]">Hiraya</Link>
          <div className="text-[10px] uppercase tracking-[0.28em] text-[#8A837A] mt-1">Admin</div>
        </div>
        <nav className="p-3 flex-1 overflow-auto">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/admin"}
                data-testid={`admin-nav-${it.label.toLowerCase()}`}
                className={({ isActive }) => `flex items-center gap-3 px-4 py-3 text-sm rounded-sm transition-colors ${isActive ? "bg-[#A85C42] text-white" : "hover:bg-[#2B2927]"}`}
              >
                <Icon size={16} strokeWidth={1.5} /> {it.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-[#3A3734]">
          <div className="text-sm">{user.name}</div>
          <div className="text-xs text-[#8A837A]">{user.email}</div>
          <div className="text-[10px] text-[#A85C42] uppercase tracking-[0.2em] mt-1">{user.role}</div>
          <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout" className="mt-4 flex items-center gap-2 text-xs text-[#EAE6DF] hover:text-[#A85C42]"><LogOut size={14} /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 md:ml-64 p-6 md:p-10 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
